module.exports = __webpack_public_path__ + "static/media/make_order.26b34440.png";